import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useMemo,
} from "react";
import {
  InlineStack,
  Card,
  ChoiceList,
  Listbox,
  TextField,
  Checkbox,
  PageActions,
  FormLayout,
  Layout,
  Page,
  DropZone,
  Modal,
  Thumbnail,
  Text,
  Toast,
  List,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import { ChannelsModal } from "./Modals/ChannelsModal";
import { GiftCardFilledMinor } from "@shopify/polaris-icons";
import axiosDefault from "axios";
import LoadingScreen from "../../Components/LoadingScreen";
import TagsInput from "react-tagsinput";
import { Switch } from "@material-ui/core";
import FormControlLabel from "@mui/material/FormControlLabel";
import JoditEditor from "jodit-react";

const AddPage = (props) => {
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const [isSaving, setIsSaving] = useState(false);
  const [titleValue, setTitleValue] = useState("");
  const [descriptionalue, setDescriptionalue] = useState("");
  const handleChangeTitle = (value) => {
    setTitleValue(value);
    setTitleError("");
    setAliasValue(slugify(value));
    setMetatitleValue(slugify(value));
  };

  const handleChangeDescription = (value) => {
    setDescriptionalue(value);
  };
  const [titleError, setTitleError] = useState("");
  const [aliasValue, setAliasValue] = useState("");
  const handleChangeAlias = (value) => {
    setAliasValue(value);
    setAliasError("");
  };
  const [instructionValue, setInstructionValue] = useState("");
  const handleChangeInstruction = (value) => {
    setInstructionValue(value);
  };
  const [aliasError, setAliasError] = useState("");
  const [contentValue, setContentValue] = useState("");
  const handleChangeContent = (newValue) => {
    setContentValue(newValue);
  };
  const [metaTitleValue, setMetatitleValue] = useState("");
  const handleChangeMetaTitle = useCallback(
    (value) => setMetatitleValue(value),
    []
  );
  const [metaDescriptionValue, setMetaDescriptionValue] = useState("");
  const handleChangeMetaDescription = useCallback(
    (value) => setMetaDescriptionValue(value),
    []
  );
  const [selected, setSelected] = useState(["visible"]);
  const handleChoiceListChange = useCallback((value) => setSelected(value), []);
  const [visibilityDateValue, setVisibilityDateValue] = useState("");
  const handleChangeVisibilityDate = useCallback(
    (newValue) => setVisibilityDateValue(newValue),
    []
  );
  const [visibilityButtonText, setVisibilityButtonText] = useState(
    "Set visibility date"
  );
  const handleVisibilityButton = () => {
    visibilityButtonText === "Set visibility date"
      ? setVisibilityButtonText("Clear date")
      : setVisibilityButtonText("Set visibility date");
  };
  const [checked, setChecked] = useState(true);
  const handleChangeChecked = useCallback(
    (newChecked) => setChecked(newChecked),
    []
  );
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFile = file && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* Uncomment if using thumbnail */}
      {/*
    <Thumbnail
      size="small"
      alt={file.name}
      source={
        validImageTypes.includes(file.type)
          ? window.URL.createObjectURL(file)
          : NoteMinor
      }
    />
    */}
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </InlineStack>
  );
  const [image, setImage] = useState("");
  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "page");
    form_data.append("seo_image[en]", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setImage(
          validImageTypes.indexOf(file[file.length - 1].type) > 0
            ? window.URL.createObjectURL(file[file.length - 1])
            : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
        );
      })
      .catch(function (error) {});
  };
  const [activeToast, setActiveToast] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const [activeChannels, setActiveChannels] = useState(false);
  const handleChangeActiveChannels = useCallback(
    () => setActiveChannels(!activeChannels),
    [activeChannels]
  );
  const handleChangeActiveChannelsDone = () => {
    setActiveChannels(false);
    setChannelsToShow(selectedChannels);
  };

  const [channels, setChannels] = useState([]);
  const [channelsToShow, setChannelsToShow] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const handleSelectedChannels = (param) => {
    setSelectedChannels(param);
  };
  const [tagsKeywords, setTagsKeywords] = useState([]);
  const handleChangeTagsKeywords = (tagsKeywords) => {
    console.log(tagsKeywords);
    setTagsKeywords(tagsKeywords);
  };
  const editor = useRef(null);
  const fileInputRef = useRef(null);

  // Configuration for Jodit
  const config2 = {
    buttons: [
      "bold",
      "italic",
      "link",
      "unlink",
      "underline",
      "source",
      "customImage",
    ],
    extraButtons: [
      {
        name: "customImage",
        iconURL: "https://img.icons8.com/material-outlined/24/000000/image.png", // Custom icon URL
        exec: (editor) => {
          fileInputRef.current.click();
        },
        tooltip: "Insert Image",
      },
    ],
    uploader: {
      insertImageAsBase64URI: false, // Do not insert images as base64
    },
  };
  const insertImageAtCursor = (imageUrl) => {
    const editorRef = editor.current;
    if (!editorRef) return;

    const selection = window.getSelection();
    if (!selection) return;

    const range = selection.getRangeAt(0);

    const newImage = document.createElement("img");
    newImage.setAttribute("src", imageUrl);
    newImage.setAttribute("alt", "Image");
    range.insertNode(newImage);
    setInstructionValue(editor.innerHTML);
  };
  const handleImageUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    formData.append("entity_type", "rich_text");

    try {
      const response = await axios.post("s3/save-file", formData);
      const imageUrl = response.data.data.file_url; // URL of the uploaded file
      const editorInstance = editor.current;
      insertImageAtCursor(imageUrl);
      // setInstructionValue(instructionValue + `<img src=${imageUrl}></img>`);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleImageUpload(file);
    }
  };
  const editorRef = useRef(null);

  const options = [
    "bold",
    "italic",
    "|",
    "ul",
    "ol",
    "|",
    "font",
    "fontsize",
    "|",
    "outdent",
    "indent",
    "align",
    "|",
    "hr",
    "|",
    "fullsize",
    "brush",
    "|",
    "table",
    "link",
    "|",
    "undo",
    "redo",
  ];

  useEffect(() => {
    axios
      .get(`/channels`)
      .then((result) => {
        setChannels(
          result.data.data.data.map((item, index) => {
            return {
              label: item.name,
              value: item.id,
              id: item.id,
            };
          })
        );
      })
      .catch(function (error) {});
  }, []);
  const [isAutomaticExport, setIsAutomaticExport] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageSelect = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
    uploadImage(file);
  };

  const uploadImage = (imageFile) => {
    const form_data = new FormData();
    form_data.append("image", imageFile);
    form_data.append("entity_type", "rich_text");
    axios
      .post("s3/save-file", form_data)
      .then((res) => {
        if (editor) {
          editor.selection.insertImage(res.data.data.file_url);
        } else {
          console.log("");
        }
      })
      .catch((err) => console.log(""));
  };
  const [suggestions, setSuggestions] = useState([]);
  const [query, setQuery] = useState("");
  const [input, setInput] = useState("");

  useEffect(() => {
    if (query.length >= 1) {
      axios
        .get(
          `/search/${
            props.type === "blogs" ? "blog" : "page"
          }/tags?query=${query}`
        )
        .then((res) => {
          console.log(res.data.data);
          setSuggestions(res.data.data);
        }) // Adjust API response format
        .catch((err) => console.error(err));
    } else {
      //setSuggestions([]);
    }
  }, [query]);
  const inputRef = useRef(null);
  const handleTyping = (newInput) => {
    setInput(newInput);
    setQuery(newInput);
  };

  // const handleKeyDown = (event) => {
  //   console.log("Key pressed:", event.key); // Logs the key pressed by the user
  // };

  // useEffect(() => {
  //   const inputElement = inputRef.current;
  //   if (inputElement) {
  //     inputElement.addEventListener("keydown", handleKeyDown);
  //   }
  //   // Clean up the event listener when the component is unmounted
  //   return () => {
  //     if (inputElement) {
  //       inputElement.removeEventListener("keydown", handleKeyDown);
  //     }
  //   };
  // }, []);
  const [dateValue, setDateValue] = useState("");
  const handleChangeDate = (newValue) => {
    setDateValue(newValue);
  };

  return (
    <Page
      title={props.title}
      backAction={{
        onAction: () => navigate(`/admin/${props.type}`),
      }}
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <TextField
              label="Title"
              value={titleValue}
              onChange={handleChangeTitle}
              error={titleError}
            />
            <TextField
              label="Description"
              value={descriptionalue}
              onChange={handleChangeDescription}
              multiline={4}
            />

            <TextField
              label="Alias"
              value={aliasValue}
              onChange={handleChangeAlias}
              error={aliasError}
            />
            <Text>Tags</Text>
            <TagsInput
              value={tagsKeywords}
              onChange={handleChangeTagsKeywords}
              inputValue={input}
              onChangeInput={handleTyping}
              inputRef={inputRef}
            />

            {suggestions.length > 0 && (
              <ul
                style={{
                  position: "absolute",
                  background: "#e9e9e9",
                  color: "black",
                  border: "1px solid #ddd",
                  listStyle: "none",
                  padding: "5px",
                  width: "200px",
                  zIndex: 1000,
                }}
              >
                {suggestions.map((suggestion) => (
                  <li
                    key={suggestion}
                    style={{ cursor: "pointer", padding: "5px" }}
                    onClick={() => {
                      setTagsKeywords([...tagsKeywords, suggestion]);
                      setSuggestions([]);
                      setInput("");
                    }}
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            )}
            {props?.type === "blogs" ? (
              <TextField
                label="Date"
                value={dateValue}
                onChange={handleChangeDate}
                type="date"
              />
            ) : null}

            <Text>Instruction</Text>
            <input
              ref={editorRef}
              type="file"
              accept="image/*"
              onChange={handleImageSelect}
              style={{ display: "none" }}
            />
            <div>
              <JoditEditor
                ref={editor}
                config={useMemo(
                  () => ({
                    readonly: false,
                    placeholder: "",
                    defaultActionOnPaste: "insert_as_html",
                    defaultLineHeight: 1.5,
                    enter: "div",
                    // options that we defined in above step.
                    buttons: [
                      "bold",
                      "italic",
                      "ul",
                      "ol",
                      "hr",
                      "fullsize",
                      "table",
                      "link",
                      "align",
                    ],
                    statusbar: false,
                    sizeLG: 900,
                    sizeMD: 700,
                    sizeSM: 400,
                    toolbarAdaptive: false,
                    toolbar: true,
                    extraButtons: [
                      {
                        name: "customImage",
                        iconURL:
                          "https://img.icons8.com/material-outlined/24/000000/image.png", // Custom icon URL
                        exec: (editor) => {
                          fileInputRef.current.click();
                        },
                        tooltip: "Insert Image",
                      },
                    ],
                    uploader: {
                      insertImageAsBase64URI: false, // Do not insert images as base64
                    },
                  }),
                  []
                )}
                value={instructionValue}
                onChange={handleChangeInstruction}
              />
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept="image/*"
              />
            </div>
            {/* <Editor
              apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
              value={instructionValue}
              init={{
                branding: false,
                height: 200,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | bold italic backcolor |  alignleft aligncenter alignright alignjustify | \bullist numlist outdent indent | removeformat | help|ltr rtl|code",
              }}
              onEditorChange={handleChangeInstruction}
            /> */}
          </FormLayout>

          {/* <Listbox accessibilityLabel="Listbox with Action example">
                <Listbox.Option value="UniqueValue-1">Item 1</Listbox.Option>
                <Listbox.Option value="UniqueValue-2" divider>
                  Item 2
                </Listbox.Option>
                <Listbox.Action value="ActionValue">
                  <Stack spacing="tight">
                    <Icon source={CirclePlusMinor} color="base" />
                    <div>Add Section</div>
                  </InlineStack>
                </Listbox.Action>
              </Listbox> */}
          {/* <Button primary>Manage Sections</Button> */}
          {/* <Text variant="bodyMd" as="p" fontWeight="regular">
                Content
              </Text>
              <Editor
                apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                value={contentValue}
                init={{
                  branding: false,
                  height: 200,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic backcolor |  alignleft aligncenter alignright alignjustify | \bullist numlist outdent indent | removeformat | help|ltr rtl|code",
                }}
                onEditorChange={handleChangeContent}
              /> */}
        </Card>
        <Card sectioned title="Search engine listing preview">
          <FormLayout>
            <Text variant="bodyMd" as="p" fontWeight="regular">
              SEO Image
            </Text>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div style={{ float: "left" }}>
                <Thumbnail size="large" source={image ? image : ""} />
              </div>
              <div
                style={{
                  width: "100%",
                  marginLeft: "10px",
                }}
              >
                <DropZone
                  accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                  //   type="file"
                  allowMultiple={false}
                  onDrop={handleDropZoneDrop}
                  onDropAccepted={sendImage}
                >
                  {uploadedFile}
                  {fileUpload}
                </DropZone>
              </div>
            </div>
            <TextField
              label="Page Title"
              value={metaTitleValue}
              onChange={handleChangeMetaTitle}
            />
            <TextField
              label="Description"
              value={metaDescriptionValue}
              onChange={handleChangeMetaDescription}
              multiline={4}
            />
          </FormLayout>
        </Card>

        <Card>
          <FormLayout>
            <Text as="p" fontWeight="bold">
              Visibility
            </Text>
            <Checkbox
              label="Is Active"
              checked={checked}
              onChange={handleChangeChecked}
            />
          </FormLayout>
        </Card>
      </FormLayout>

      <Modal
        open={activeChannels}
        onClose={handleChangeActiveChannels}
        title="Manage Channels"
        primaryAction={{
          content: "Done",
          onAction: handleChangeActiveChannelsDone,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChangeActiveChannels,
          },
        ]}
      >
        <Modal.Section>
          <ChannelsModal
            channels={channels}
            handleSelectedChannels={handleSelectedChannels}
            selectedChannels={selectedChannels}
          />
        </Modal.Section>
      </Modal>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!titleValue || !aliasValue) {
      !titleValue && setTitleError("This field is required");
      !aliasValue && setAliasError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      titleValue && form_data.append("title[en]", titleValue);
      titleValue && form_data.append("description[en]", descriptionalue);
      aliasValue && form_data.append("alias", aliasValue.replaceAll(" ", "-"));
      metaTitleValue && form_data.append("seo_title[en]", metaTitleValue);
      form_data.append("date", dateValue);
      // selectedChannels && selectedChannels.length
      //   ? selectedChannels.forEach((selected, index) =>
      //       form_data.append(`channels[${index}]`, selected)
      //     )
      //   : form_data.append(`channels`, []);
      tagsKeywords?.length &&
        tagsKeywords.forEach((selected, index) =>
          form_data.append(`tags[${index}]`, selected)
        );
      metaDescriptionValue &&
        form_data.append("seo_description[en]", metaDescriptionValue);
      file && form_data.append("seo_image[en]", imageKey.current);
      form_data.append("is_active", checked ? 1 : 0);
      instructionValue && form_data.append("instructions", instructionValue);
      axios
        .post(`/${props.type}`, form_data)
        .then((res) => {
          navigate(`/admin/${props.type}`);
        })
        .catch(function (error) {
          if (error.response) {
            setToastContent(error.response.data.message);
            toggleActiveToast();
            setIsSaving(false);
          }
        });
    }
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
};

export default AddPage;
